import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { merge as mergeObjects } from "lodash";

import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import ErrorLine from "../elements/ErrorLine";
import formdata from "../../data/formdata";
import { getResponse, dispError, dispSuccess } from "../../utils/Tools";

function FormUser(props) {
  const appDispatch = useContext(DispatchContext);

  const validation = Yup.object({
    salutation: Yup.string().required("Bitte wählen Sie eine Anrede aus."),
    firstname: Yup.string().required("Bitte geben Sie einen Vornamen ein."),
    lastname: Yup.string().required("Bitte geben Sie einen Nachnamen ein."),
    email: Yup.string().email("Keine gültige E-Mail-Adresse").required("Bitte geben Sie eine E-Mail-Adresse ein."),
    type: Yup.string().required("Bitte wählen Sie die Rechte des Benutzers aus.")
  });

  const defaultValues = {
    salutation: "",
    firstname: "",
    lastname: "",
    email: "",
    type: ""
  };
  let initialValues = { ...defaultValues };

  // Edit user
  if (props.prefill) mergeObjects(initialValues, props.prefill);

  const targetURL = props.modus && props.modus === "edit" ? "UPDATE" : "CREATE";

  const onSubmit = (values, { resetForm, setSubmitting }) => {
    let payload = { ...values };
    if (props.modus && props.modus === "edit") payload._id = props.prefill._id;
    DataFetcher.fetch(DataFetcher.USER[targetURL], payload)
      .then(response => {
        if (!response.success) {
          setSubmitting(false);
          return appDispatch(dispError(response.msg));
        }
        let msg = props.modus === "edit" ? getResponse("005") : getResponse("004");
        appDispatch(dispSuccess(msg));
        if (props.modus === "edit") {
          props.onUpdate();
        } else {
          resetForm({ values: "" });
          // appDispatch({ type: "user-created" });
        }
      })
      .catch(error => {
        console.error(error);
        setSubmitting(false);
      });
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting }) => (
        <Form autoComplete="on">
          <div className="field">
            <label className="label">Anrede*</label>
            <div className="control">
              <div className={`select${touched.salutation && errors.salutation ? " is-danger" : ""}`}>
                <Field as="select" name="salutation">
                  <option>Wählen</option>
                  {formdata.salutation.map((item, index) => {
                    return (
                      <option key={`state-${index}`} value={item[0]}>
                        {item[1]}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
            <ErrorMessage component={ErrorLine} name="salutation" />
          </div>
          <div className="field field-body">
            <div className="field">
              <label className="label">Vorname*</label>
              <div className="control">
                <Field name="firstname" type="text" className={`input${touched.firstname && errors.firstname ? " is-danger" : ""}`} />
              </div>
              <ErrorMessage component={ErrorLine} name="firstname" />
            </div>
            <div className="field">
              <label className="label">Nachname*</label>
              <div className="control">
                <Field name="lastname" type="text" className={`input${touched.lastname && errors.lastname ? " is-danger" : ""}`} />
              </div>
              <ErrorMessage component={ErrorLine} name="lastname" />
            </div>
          </div>
          <div className="field">
            <label className="label">E-Mail-Adresse*</label>
            <p className="control has-icons-left">
              <Field name="email" type="email" className={`input${touched.email && errors.email ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="email" />
          </div>
          <div className="field">
          <label className="label">Rechte*</label>
            <div className="control">
              <div className={`select${touched.type && errors.type ? " is-danger" : ""}`}>
                <Field as="select" name="type">
                  <option>Wählen</option>
                  {formdata.user_types.map((item, index) => {
                    return (
                      <option key={`usertype-${index}`} value={item[0]}>
                        {item[1]}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
            <ErrorMessage component={ErrorLine} name="type" />
          </div>
          <hr />
          <div className="field">
            <div className="control field-body">
              <button className="button is-success" type="submit" disabled={isSubmitting}>
                Speichern
              </button>
              <button className="button ml-2" type="button" onClick={props.onCancel}>
                Abbrechen
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default FormUser;
